import axios from "axios";
import {url} from "../crudRequests";

// The journal companion. The portal sends the day and the patient's words; the
// server owns the instructions, saves both sides and answers the reply only
// (blhWebServer src/domain/journal/companionReply.js). Days are read without the
// note the companion keeps for the clinic (src/domain/journal/journalDay.js).

function authHeaders(state) {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + state.jwt,
      "X-Tenant": "patient",
    },
    withCredentials: true,
  };
}

/**
 * One message to the companion.
 * @returns {Promise<{reply: string, answered: boolean, crisis: boolean}>}
 */
export async function sendJournalMessage(state, {date, text}) {
  const response = await axios.post(`${url}/patient-app/journal/reply`, {date, text}, authHeaders(state));
  const {reply, answered, crisis} = response.data || {};
  return {reply: typeof reply === "string" ? reply : "", answered: answered === true, crisis: crisis === true};
}

/** The days with something to read, newest first. */
export async function listJournalDays(state) {
  const response = await axios.get(`${url}/patient-app/journal/days`, authHeaders(state));
  const days = response.data?.days;
  return Array.isArray(days) ? days : [];
}

/**
 * One day as the patient sees it.
 * @returns {Promise<{date: string, persona: string|null, entries: {author: string, text: string}[], crisis: boolean}>}
 */
export async function readJournalDay(state, date) {
  const response = await axios.get(`${url}/patient-app/journal/days/${date}`, authHeaders(state));
  const day = response.data?.day || {};
  return {
    date,
    persona: typeof day.persona === "string" ? day.persona : null,
    entries: Array.isArray(day.entries) ? day.entries : [],
    crisis: day.crisis === true,
  };
}

export async function setJournalPersona(state, date, persona) {
  await axios.put(`${url}/patient-app/journal/days/${date}/persona`, {persona}, authHeaders(state));
}

/** Hides the day from the patient; the clinic keeps it. */
export async function clearJournalDay(state, date) {
  await axios.post(`${url}/patient-app/journal/days/${date}/clear`, {}, authHeaders(state));
}
